import styles from "./AuthPageShell.module.scss";

export const AUTH_DESKTOP_BG = `${process.env.PUBLIC_URL}/images/login-desktop-bg.png`;

/**
 * Shared full-viewport layout for IdP flows: campaign background + right column (9:16 desktop).
 * Pass scrollable body as children; optional footer renders inside the panel (e.g. docked button).
 * scrollFooterReserve: extra bottom padding when a docked footer exists or fixed CTAs below scroll (default true).
 */
const AuthPageShell = ({
	children,
	footer = null,
	scrollFooterReserve = true,
}) => {
	const scrollClass = scrollFooterReserve
		? styles.authPanelScroll
		: styles.authPanelScrollCompact;

	return (
		<div
			className={styles.authShell}
			style={{ backgroundImage: `url(${AUTH_DESKTOP_BG})` }}
		>
			<div className={styles.authPanel}>
				<div className={scrollClass}>{children}</div>
				{footer}
			</div>
		</div>
	);
};

export default AuthPageShell;
